// frontend/src/api/valuationCompany.ts
//
// VAL-COMPANY-PROFILE-1B — save the engagement's company profile. One PATCH
// endpoint, one client function: this delegates to updateValuationEngagement
// in valuation.ts. The body carries `company_profile` and nothing else, so it
// can never touch another engagement field. `null` clears the profile.

import { updateValuationEngagement } from '@/api/valuation'
import type { UpdateEngagementBody } from '@/types/valuation'
import type { CompanyProfile, EngagementWithCompany, IndustryFacts } from '@/types/valuationCompany'

export async function saveCompanyProfile(
  id: string,
  profile: CompanyProfile | null,
  industryFacts?: IndustryFacts | null,
): Promise<EngagementWithCompany> {
  // UpdateEngagementBody predates company_profile; widen it here, not there.
  const body: UpdateEngagementBody & { company_profile: CompanyProfile | null; industry_facts?: IndustryFacts | null } =
    { company_profile: profile }
  // Only when passed: undefined leaves the key out, null clears this industry's facts.
  if (industryFacts !== undefined) body.industry_facts = industryFacts
  return (await updateValuationEngagement(id, body)) as EngagementWithCompany
}
